(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[334],{

/***/ 24391:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ BulletedList; }
/* harmony export */ });
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(32125);
/* harmony import */ var _styles_theme__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(49642);


var BulletedList = styled_components__WEBPACK_IMPORTED_MODULE_1__/* ["default"].ul.withConfig */ .ZP.ul.withConfig({
  displayName: "BulletedList",
  componentId: "sc-ep09my-0"
})(["font-size:16px;line-height:1.3;list-style:", ";margin-left:24px;display:flex;flex-direction:column;gap:21px;> li::marker{color:", ";}@media screen and (max-width:1047px){font-size:15px;line-height:1.6;gap:12px;}"], function (_ref) {
  var listStyle = _ref.listStyle;
  return listStyle !== null && listStyle !== void 0 ? listStyle : 'disc';
}, function (_ref2) {
  var listStyle = _ref2.listStyle;
  return listStyle === 'decimal' ? _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.textTitle */ .r.colors.textTitle : _styles_theme__WEBPACK_IMPORTED_MODULE_0__/* .theme.colors.grey */ .r.colors.grey;
});

/***/ }),

/***/ 65432:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* reexport */ DisclosurePage; }
});

// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(32125);
// EXTERNAL MODULE: ./src/components/elements/SectionTitle/index.tsx
var SectionTitle = __webpack_require__(70770);
// EXTERNAL MODULE: ./src/components/elements/Spacer/index.tsx
var Spacer = __webpack_require__(1253);
// EXTERNAL MODULE: ./src/components/enlayout.tsx + 7 modules
var enlayout = __webpack_require__(34591);
// EXTERNAL MODULE: ./src/components/enlayouts/Head/index.tsx
var Head = __webpack_require__(32056);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/index.tsx + 3 modules
var Ir = __webpack_require__(82319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/BulletedList.tsx
var BulletedList = __webpack_require__(24391);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Heading.tsx
var Heading = __webpack_require__(3319);
// EXTERNAL MODULE: ./src/components/enlayouts/Ir/Paragraph.tsx
var Paragraph = __webpack_require__(81507);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./src/components/enpages/Ir/Manage/Disclosure/index.tsx












var DisclosurePage = function DisclosurePage() {
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(Ir/* Layout */.A, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(SectionTitle/* SectionTitle */.N, {
      color: "normal",
      enTitleText: "Disclosure / IR Policy",
      subTitleText: ""
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
      h: {
        sp: 70,
        pc: 120
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)("section", {
      children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "Disclosure Policy"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["TRIAL Group aims to \"Revolutionize the retail industry with technology\" through the combination of Distribution and IT.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We embrace the purpose \"Enrich every aspect of people's lives through all we do.\" In pursuit of this, we strive for prompt, accurate, and fair disclosure, engaging in constructive dialogue with all stakeholders.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Through this ongoing commitment, we seek to enhance transparency in management, fulfill corporate social responsibilities, and earn trust. We disseminate this fundamental policy internally and externally, establishing the following Disclosure Policy to consistently implement our disclosures with appropriate standards, methods, and systems."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 50,
          pc: 80
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "1. Standards for Information Disclosure"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["Our company will consistently disclose information in accordance with the provisions of the Companies Act, the Financial Instruments and Exchange Act, other relevant laws and regulations, as well as the \"Timely Disclosure Rules\" stipulated by the Tokyo Stock Exchange.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "In the event of material decisions, occurrences, or financial information that could significantly impact investment decisions, we will promptly disclose such information in accordance with the standards of the Timely Disclosure Rules. Additionally, even in cases not covered by the Timely Disclosure Rules, we will proactively disclose information that we deem important or beneficial for stakeholders to understand our company, enhancing fairness in information access.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "It should be noted that information that could violate personal privacy, customer information, or infringe upon the rights of stakeholders will not be disclosed."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "2. Methods of Information Disclosure"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["For information falling under the Timely Disclosure Rules, we will register and publicly release it on the \"TDnet (Timely Disclosure Information Transmission System)\" provided by the Tokyo Stock Exchange. Subsequently, we will promptly publish the information on our company website.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "For information not covered by the Timely Disclosure Rules, we will also disclose it widely through means such as publication on our website."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "3. Prevention of Insider Trading"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "Our company has established internal regulations to appropriately manage sensitive information and prevent insider trading, fostering widespread awareness and understanding among all employees in the group."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "4. Handling of Performance Forecasts and Future Information"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Paragraph/* Paragraph */.n, {
        children: "Descriptions of performance forecasts, strategies, policies, goals, etc., disclosed by our company that are not historical facts constitute forward-looking statements regarding future outlook. These statements are based on plans, expectations, and judgments relying on information available to the company at that time and deemed reasonable under certain assumptions. Actual performance may vary significantly due to various risks and uncertainties."
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "5. Quiet Period"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["To ensure fairness to all our stakeholders, our company observes the quiet period starting one month prior to each quarterly earnings announcement.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "During this period, we refrain from answering questions or making comments regarding our financial results or earnings forecasts. However, if we anticipate a significant deviation from our previously announced earnings forecast during the quiet period, we will make an appropriate disclosure in accordance with timely disclosure rules."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* BHeading */.Zg, {
        children: "6. Establishment of Internal Structure"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["Our company ensures the effective operation of the Disclosure Policy and establishes a framework to execute timely and appropriate information disclosure based on the Timely Disclosure Rules.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "We have organized an information disclosure department that collaborates with various operational departments within the company. This department is responsible for proper information gathering and analysis. We have clarified the process from the occurrence of information to disclosure, ensuring that the company makes disclosures based on sound judgment."]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 30
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Image, {
        src: "/images/TRIAL_Disclosure_IR_Policy_EN.png",
        alt: "\u9069\u6642\u958B\u793A\u4F53\u5236",
        width: "100%"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 80,
          pc: 100
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Heading/* AHeading */.Os, {
        children: "IR Policy"
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["Our company, through the combination of distribution and IT, undertakes the mission of contributing to the elimination of waste, non-value-added activities, and inefficiencies in the retail industry while being helpful to our customers. Our Investor Relations (IR) activities aim to execute prompt, accurate, and fair disclosure and constructive dialogue with stakeholders, including shareholders and investors, under the following principles.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "To enhance our corporate value, it is crucial for stakeholders to have a correct understanding of our company. Therefore, we adhere to the Disclosure Policy and disclose information regarding our management philosophy, mission and role, management policies, business activities, performance, financial status, various management indicators, shareholder return policies and achievements, medium-term management plans, and future prospects, ensuring accurate and timely disclosure.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Dialogue with stakeholders such as shareholders and investors is facilitated by the IR department and the management teams of various departments. To enhance the effectiveness of these dialogues, the IR department takes the lead, closely collaborating with corporate departments such as finance and accounting, general affairs, and others. In order to create a basis for constructive dialogue, the following initiatives are undertaken:"]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(BulletedList/* BulletedList */.h, {
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Conducting financial results briefings, company presentations, and facility tours"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Responding to inquiries from institutional investors and individual interviews"
        }), /*#__PURE__*/(0,jsx_runtime.jsx)("li", {
          children: "Publishing materials from financial results and company briefings on the website"
        })]
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(Spacer/* Spacer */.L, {
        h: {
          sp: 30,
          pc: 50
        }
      }), /*#__PURE__*/(0,jsx_runtime.jsxs)(Paragraph/* Paragraph */.n, {
        children: ["Knowledge gained through communication with stakeholders is regularly reported to the management to inform business decisions.", /*#__PURE__*/(0,jsx_runtime.jsx)("br", {}), "Through IR activities, we aim to deepen the understanding of our company among stakeholders and improve our corporate and brand value."]
      })]
    })]
  });
};

DisclosurePage.getLayout = function (page) {
  var breadCrumbs = [{
    name: 'Home',
    path: '/en/'
  }, {
    name: 'Investor Relations',
    path: '/en/ir/'
  }, {
    name: 'Management Policy',
    path: '/en/ir/manage'
  }, {
    name: 'Disclosure / IR Policy',
    path: ''
  }];
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Head/* Head */.F, {
      title: "Disclosure / IR Policy",
      description: "The basic policy regarding IR activities.",
      ogp: {
        url: 'en/ir/manage/disclosure/'
      }
    }), /*#__PURE__*/(0,jsx_runtime.jsx)(enlayout/* TitleLayout */.$0, {
      title: "Investor Relations",
      subTitle: "",
      breadCrumbs: breadCrumbs,
      children: page
    })]
  });
};

var Image = styled_components_browser_esm/* default.img.withConfig */.ZP.img.withConfig({
  displayName: "Disclosure__Image",
  componentId: "sc-deg009-0"
})(["height:100%;"]);
;// CONCATENATED MODULE: ./src/pages/en/ir/manage/disclosure.tsx


/***/ }),

/***/ 9481:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ir/manage/disclosure",
      function () {
        return __webpack_require__(65432);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1228,3874,2768,4591,4123,9774,2888,179], function() { return __webpack_exec__(9481); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);